import { createFileRoute } from '@tanstack/react-router';

import { OfferEditFlow } from '../offer/edit/OfferEditFlow';

export const Route = createFileRoute('/_app/offer/$id_/edit')({
    component: OfferEditFlow,
});
